
    /*!
    * Copyright (c) Microsoft Corporation.
    * All rights reserved. See LICENSE in the project root for license information.
    * THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
    * TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
    */
    import {
        AsyncResult,
        callActionOrExecute,
        DataServiceQuery,
        IContext,
        IDataServiceRequest,
        //IQueryResultSettings,
        // @ts-ignore -- Unused import
        NullResult
    } from '@msdyn365-commerce/retail-proxy';
    // @ts-ignore -- Unused import
    import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
    // @ts-ignore -- Unused import
    import * as Entities from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
    import * as DataServiceEntities from './DataServiceEntities.g';

    

        // @ts-ignore
        function getZendeskDetailsQuery(rECID?: string): DataServiceQuery {
        const key = (rECID) ? { RECID: rECID } :null;
        return new DataServiceQuery("GetZendeskDetails", "ZendeskEntity", DataServiceEntities.ZendeskEntityExtensionClass, key);
        }

        
    export function createGetZendeskDetailsActionInput(name: string, email: string): IDataServiceRequest {
    const query = getZendeskDetailsQuery();
    return query.createDataServiceRequestForOperation('GetZendeskDetailsAction', true, DataServiceEntities.ZendeskEntityExtensionClass, 'false', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IZendeskEntity'}, {name: name, email: email });
    }

    
    export function getZendeskDetailsActionAsync(context: IContext, name: string, email: string): AsyncResult<DataServiceEntities.IZendeskEntity> {
    const request = createGetZendeskDetailsActionInput(name, email);
    return callActionOrExecute<DataServiceEntities.IZendeskEntity>(request, context.callerContext);
    }
  